import React, {useContext, useEffect, useState} from 'react';
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import OpenListDesignerButton from "./PropertiesForm/OpenListDesignerButton";
import UploadFileProperties from "./PropertiesForm/UploadFileProperties";
import {OpenTextEditor, TextEditor} from "./PropertiesForm/OpenTextEditor";
import ListDesignerModal from "../../../../../../../ListDesigner/ListDesignerModal";
import {useHistory} from "react-router";
import FormDynamic from "../../../../../../../../Utils/Form/FormDynamic";
import Entities from "../Entities/Entities";
import OpenContextDesigner from "./PropertiesForm/OpenContextDesigner";
import {fixBrokenParams} from "../../../utils/lib";
import ShortcutInput from "./PropertiesForm/ShortcutInput";
import {useComponentProperties} from "./generateProperties";

const ComponentProperties = () => {
    const history = useHistory();
    const {
        selectedComponent = {},
        screenValues,
        onChangeDefaultFields,
        preparedToSaveLists,
        setImageContent,
        openListDesigner,
        toggleListDesigner,
        setSelectedComponent,
        addNewList,
    } = useContext(ScreenDesignerContextNew);
    const {component} = selectedComponent;
    const [openTextEditor, setOpenTextEditor] = useState(false);
    const [openContextDesigner, setOpenContextDesigner] = useState(false);
    const [currentContextValues, setCurrentContextValues] = useState(null);
    const [componentPath, setComponentPath] = useState('');

    const schema = useComponentProperties();

    useEffect(() => {
        if (selectedComponent.path.split('.')[0] === 'listObject') {
            const splited = selectedComponent.path.split('.');
            const newPath = splited.slice(1).join('.');
            setComponentPath(newPath);
            return
        }
        setComponentPath(selectedComponent.path)

    }, [JSON.stringify(selectedComponent)]);

    function onChangeFields(value, path, trackChange, fromDropdown) {
        if (component.type.match(/list|forEach|feed/) && fromDropdown) {
            addNewList(value)
        }

        onChangeDefaultFields(value, path)
    }

    //list designer toggle
    function onOpenListDesigner() {
        //if no props, insert empty value
        if (!component.properties) {
            const path = component.type === 'list' ? `${componentPath}.properties.name` : `${componentPath}.properties.list`
            onChangeDefaultFields('', path)
        }
        const listName = component.properties ? component.type === 'list' ? component.properties.name : component.properties.list : "";
        toggleListDesigner(listName)
    }

    function setNewList(listId) {
        onChangeDefaultFields(listId, `${componentPath}.properties.name`)
    }

    function onOpenTextEditor() {
        setOpenTextEditor(true)
    }

    function onCloseTextEditor() {
        setOpenTextEditor(false)
    }

    function onApplyTextEditor(value) {
        //save new text in text component
        let textWithFixedParams = value;
        if (typeof value === 'object') {
            Object.keys(value).map(key => {
                value[key] = fixBrokenParams(value[key])
            })
        }
        onChangeDefaultFields(textWithFixedParams, `${componentPath}.properties.label`);
        setOpenTextEditor(false)
    }

    function onOpenContext() {
        setCurrentContextValues(selectedComponent.component);
        let convertedContext = {
            name: selectedComponent.component.properties ? selectedComponent.component.properties.name : '',
            description: selectedComponent.component.properties ? selectedComponent.component.properties.description : '',
            main: []
        };

        //convert component to contextDesigner items instance
        for (let item of selectedComponent.component.children || []) {
            let currentItem = {
                label: item.properties.label,
                icon: item.properties.icon,
                events: item.events
            };

            convertedContext.main.push(currentItem)
        }

        setCurrentContextValues(convertedContext);
        setOpenContextDesigner(component.properties.context)
    }

    function onSaveContext(value) {
        const contextObject = {
            ...selectedComponent.component,
            properties: {
                name: value.name,
                description: value.description
            },
            children: []
        };

        //transform structure to screen designer component instance
        for (let item of value.main) {
            const currentItem = {
                properties: {
                    label: item.label,
                    icon: item.icon
                },
                events: item.events || [{
                    event: 'onClick', actions: [
                        {type: '', param: []}
                    ]
                }],
                children: []
            };
            contextObject.children.push(currentItem)
        }

        onChangeDefaultFields(contextObject, selectedComponent.path);
        setSelectedComponent({path: selectedComponent.path, component: contextObject})
    }

    return (
        <>
            {schema && (
                <>
                    <FormDynamic
                        field={{label: 'ID', name: 'id', type: 'string', path: `${componentPath}.id`, disabled: true}}
                        setValue={onChangeFields}
                        fieldStyles={{width: '220px'}}
                        labelStyles={{width: '100px'}}
                        values={selectedComponent.isListObject ? preparedToSaveLists : screenValues}
                        setValueOnChange
                    />
                    {(schema || []).map((element, index) => {
                        return (
                            <FormDynamic
                                key={index}
                                field={{
                                    ...element,
                                    path: `${componentPath}.properties${element.name ? '.' + element.name : ''}`,
                                    disabled: component._isLocked
                                }}
                                setValue={onChangeFields}
                                fieldStyles={{width: '220px'}}
                                labelStyles={{width: '100px'}}
                                values={selectedComponent.isListObject ? preparedToSaveLists : screenValues}
                                renderOptions={element.renderOptions}
                                setValueOnChange
                            />
                        )
                    })}
                </>
            )}
            {component.type && component.type.match(/list|forEach|feed/) && (
                <OpenListDesignerButton openListDesigner={onOpenListDesigner}/>
            )}
            {component.type === 'image' && (
                <UploadFileProperties setImageContent={setImageContent}/>
            )}
            {component.type === 'text' && (
                <OpenTextEditor openTextEditor={onOpenTextEditor}/>
            )}
            {component.type === 'context' && (
                <OpenContextDesigner
                    isOpen={openContextDesigner}
                    onOpen={onOpenContext}
                    onClose={() => {
                        setOpenContextDesigner(false);
                        setCurrentContextValues(null)
                    }}
                    currentValues={openContextDesigner}
                    onSave={onSaveContext}
                />
            )}
            {openListDesigner.open && (
                <ListDesignerModal
                    listId={openListDesigner.listId} //get from state
                    setNewList={setNewList}
                    //predefinedListValues={predefinedListValues} //get from state
                    onClose={toggleListDesigner}
                    history={history}
                />
            )}
            {component.type === 'entity' && (
                <Entities/>
            )}
            {component.type === 'shortcut' && (
                <ShortcutInput/>
            )}
            {openTextEditor && (
                <TextEditor
                    onClose={onCloseTextEditor}
                    open={openTextEditor}
                    value={component.properties.label}
                    apply={onApplyTextEditor}
                />)}
        </>
    )
};

export default ComponentProperties;